export default __webpack_public_path__ + "static/media/error404bg.a2c6734d.png";